// import { Accordion } from "@admin/components/molecules/Accordion";
import { HeroSection } from "@admin/components/organisms/HeroSection";
import { useCompanyAdminInfo } from "@admin/hooks/useCompanyAdminInfo";
import {
  CompanyLocation,
  getLicensesAndTabUsers,
  getLocationsByCompany,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";

import { ActiveLocations } from "./components/ActiveLocations";
import { InactiveLocations } from "./components/InactiveLocations";

export default function LocationsPage() {
  const { companyAdminInfo: company } = useCompanyAdminInfo();

  const { data: locations, isPending } = useQuery({
    queryKey: ["allLocations", company?.companyId],
    queryFn: () => getLocationsByCompany(company?.companyId ?? ""),
    enabled: !!company?.companyId,
  });

  const [activeLocations, inactiveLocations] = (locations ?? []).reduce(
    ([active, inactive], location) =>
      location.isDeleted
        ? [active, [...inactive, location]]
        : [[...active, location], inactive],
    [[], []] as [CompanyLocation[], CompanyLocation[]],
  );
  const { data: licensesAndTabUsers } = useQuery({
    queryKey: ["licensesAndTabUsers", activeLocations, company],
    queryFn: () =>
      getLicensesAndTabUsers(activeLocations, company?.companyId ?? ""),
    enabled: !!activeLocations && !!company,
  });

  const [licenses, tabUsers] = licensesAndTabUsers ?? [];

  return (
    <>
      <HeroSection />
      <div className="flex flex-col gap-7.5">
        <ActiveLocations
          isLoading={isPending}
          companyId={company?.companyId ?? ""}
          locations={activeLocations.map((location, index) => ({
            ...location,
            tabUser: tabUsers?.find(
              (tabUser) => tabUser.companyLocationId === location.id,
            ),
            licenses: licenses?.[index],
          }))}
        />
        <InactiveLocations
          isPending={isPending}
          locations={inactiveLocations}
          companyId={company?.companyId ?? ""}
        />

        {/* <Accordion /> */}
      </div>
    </>
  );
}
